import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormErrorsComponent } from './components/form-errors/form-errors.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxLoadingComponent } from './components/ngx-loader/ngx-loader.component';

import { OverlayPanelModule } from 'primeng/overlaypanel';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DialogModule } from 'primeng/dialog';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { KeyPatternControllerDirective } from './directives/key-pattern-controller.directive';
import { ConfirmationMsgComponent } from './components/confirmation-msg/confirmation-msg.component';
import { DateDisplayChatPipe } from './pipes/date-display-chat.pipe';
import { DatePipe } from '@angular/common';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SendEmailPopupComponent } from './components/send-email-popup/send-email-popup.component';
import { FileInputAccessorModule } from 'file-input-accessor';
import { EditorModule } from 'primeng/editor';
import { AddressComponentComponent } from './components/address-component/address-component.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CustomFieldFormComponent } from './components/custom-field-form/custom-field-form.component';
import { TdCopiedComponent } from './components/td-copied/td-copied.component';
import { SettingDropdownComponent } from './components/setting-dropdown/setting-dropdown.component';
import { ImportRecordsComponent } from './components/import-records/import-records.component';
import { ImportProductionFileComponent } from './components/import-production-file/import-production-file.component';
import {
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarModule } from 'primeng/progressbar';
import { DecimalFormatPipe } from './pipes/decimal-format.pipe';
import { ExportRecordsComponent } from './components/export-records/export-records.component';
import { CheckboxModule } from 'primeng/checkbox';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { SwitchOrganizationsComponent } from './components/switch-organizations/switch-organizations.component';
import { NgxMaskModule } from 'ngx-mask';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClientsFormComponent } from './components/clients-form/clients-form.component';
import { CancelQuoteComponent } from './components/cancel-quote/cancel-quote.component';
import { CalendarModule } from 'primeng/calendar';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { QuoteDataComponent } from './components/quote-data/quote-data.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { ApproveCancellationComponent } from './components/approve-cancellation/approve-cancellation.component';
import { CancelInfoComponent } from './components/cancel-info/cancel-info.component';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { TooltipModule } from 'primeng/tooltip';
import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first-letter.pipe';
import { InfoRowComponent } from './components/info-row/info-row.component';
import { CardComponent } from './components/card/card.component';
import { ThirdPartiesBannerComponent } from './components/third-parties-banner/third-parties-banner.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SortByComponent } from './components/sort-by/sort-by.component';
import { FilterByComponent } from './components/filter-by/filter-by.component';
import { RadiobuttonsComponent } from './components/radiobuttons/radiobuttons.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { StatusComponent } from './components/status/status.component';
import { DataCardComponent } from './components/data-card/data-card.component';
import { TableFilterBarComponent } from './components/table-filter-bar/table-filter-bar.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CircleProgressComponent } from './components/circle-progress/circle-progress.component';
import { BoldLabelInfoRowComponent } from './components/bold-label-info-row/bold-label-info-row.component';
import { UploadLogoComponent } from './components/upload-logo/upload-logo.component';
import { FromUnderscoreToTextPipe } from './pipes/from-underscore-to-text.pipe';
import { VehicleAgePipe } from './pipes/vehicle-age.pipe';
import { ChartModule } from 'primeng/chart';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { MenusNavBarComponent } from './components/menus-nav-bar/menus-nav-bar.component';
import { DateRangeOptionsComponent } from './components/date-range-options/date-range-options.component';
import { DateRangeSelectorComponent } from './components/date-range-selector/date-range-selector.component';
import { MapToNamePipe } from './pipes/map-to-name.pipe';
import { TagModule } from 'primeng/tag';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { MenusChartComponent } from './components/menus-chart/menus-chart.component';
import { HideIfDirective } from './directives/hide-if.directive';
import { AssignProductToThirdPartyComponent } from './components/assign-product-to-third-party/assign-product-to-third-party.component';
import { ThirdPartyFormComponent } from './components/third-party-form/third-party-form.component';
import { ThirdPartyValidationModalComponent } from './components/third-party-validation-modal/third-party-validation-modal.component';
import { AllowZeroPipe } from './pipes/allow-zero.pipe';
import { AddAttachmentModalComponent } from './components/add-attachment-modal/add-attachment-modal.component';
import { DisableControlDirective } from './directives/disable-control.directive';
import { ViewFileComponent } from './components/view-file/view-file.component';
import { CopyLinkComponent } from './components/copy-link/copy-link.component';
import { AddNewVehicleComponent } from './components/add-new-vehicle/add-new-vehicle.component';
import { VehicleFormComponent } from './components/vehicle-form/vehicle-form.component';
import { ListContractComponent } from './components/list-contract/list-contract.component';
import { BulkChangeContractStatusModalComponent } from './components/list-contract/bulk-change-contract-status-modal/bulk-change-contract-status-modal.component';
import { ClaimListComponent } from './components/claim-list/claim-list.component';
import { SurchargeFormComponent } from './components/surcharge-form/surcharge-form.component';
import { SurchargesListComponent } from './components/surcharges-list/surcharges-list.component';
import { MenuOptionComponent } from './components/menu-option/menu-option.component';
import { ImportBtnComponent } from './components/import-btn/import-btn.component';
import { ExportBtnComponent } from './components/export-btn/export-btn.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ClaimsListCardComponent } from './components/claims-list-card/claims-list-card.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { EmailDetailsComponent } from './components/email-details/email-details.component';
import { HtmlContentComponent } from './components/html-content/html-content.component';
import { EmailContentComponent } from './components/email-content/email-content.component';
import { SendEmailSampleComponent } from './components/send-email-sample/send-email-sample.component';
import { UploaddedFilesListComponent } from './components/uploadded-files-list/uploadded-files-list.component';
import { TrimInputDirective } from './directives/trim-input.directive';
import { InputChangeDebounceDirective } from './directives/input-change-debounce.directive';
import { ValidFieldInfoComponent } from './components/valid-field-info/valid-field-info.component';
import { CoinsPipe } from './pipes/coins.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { SelectProductComponent } from './components/select-product/select-product.component';
import { ActiveFilterNamePipe } from './components/table-filter-bar/active-filter-name.pipe';
import { InfoIconComponent } from './components/info-icon/info-icon.component';
import { FlaggedUserComponent } from './components/flagged-user/flagged-user.component';
import { RemoveNullPipe } from './pipes/remove-null.pipe';
import { PendingPageComponent } from './components/pending-page/pending-page.component';
import { AmericanDatetimeFormatPipe } from './pipes/american-datetime-format.pipe';
import { DocumentPreviewComponent } from './components/document-preview/document-preview.component';
import { NewNotificationsPopupComponent } from './components/new-notifications-popup/new-notifications-popup.component';
import { CreateNoteModalComponent } from './components/create-note-modal/create-note-modal.component';
import { CreateThirdPartyModalComponent } from './components/create-third-party-modal/create-third-party-modal.component';
import { PrintQuoteContentComponent } from './components/print-quote-content/print-quote-content.component';
import { RatesListComponent } from './components/rates-list/rates-list.component';
import { SubClientFormComponent } from './components/sub-client-form/sub-client-form.component';
import { FormattedDatePipe } from './pipes/formatted-date.pipe';
import { FormattedDateTimePipe } from './pipes/formatted-date-time.pipe';
import { FormattedCurrencyPipe } from './pipes/formatted-currency.pipe';
import { UserActivityLogDialogComponent } from './components/user-activity-log-dialog/user-activity-log-dialog.component';
import { SearchComponent } from './components/search/search.component';
import { UpdateUserPasswordModalComponent } from './components/update-user-password-modal/update-user-password-modal.component';
import { AllLettersCapitalPipe } from "./pipes/all-letters-capital.pipe";
import { LogsComponent } from './components/logs/logs.component';
import { MentionInputComponent } from './components/mention-input/mention-input.component';
import { PermissionDeniedPopupComponent } from './components/permission-denied-popup/permission-denied-popup.component';
import { CancelledContractsListComponent } from './components/cancelled-contracts-list/cancelled-contracts-list.component';
import { ApiDropdownComponent } from './components/api-dropdown/api-dropdown.component';
import { DemoBannerComponent } from './components/demo-banner/demo-banner.component';
import { UserWidgetControlModalComponent } from './components/user-widget-control-modal/user-widget-control-modal.component';
import { ApprovalEmailsComponent } from './components/approval-emails/approval-emails.component';
import { AgentThirdPartiesComponent } from './components/agent-third-parties/agent-third-parties.component';
import { AppIconComponent } from './components/app-icon/app-icon.component';
import { StatCardComponent } from './components/stat-card/stat-card.component';
import { StatusPillComponent } from './components/status-pill/status-pill.component';
import { TabBarNewComponent } from './components/tab-bar-new/tab-bar-new.component';
import { PageHeaderNewComponent } from './components/page-header-new/page-header-new.component';
import { PaginationNewComponent } from './components/pagination-new/pagination-new.component';
import { SearchInputNewComponent } from './components/search-input-new/search-input-new.component';
import { FilterControlComponent } from './components/filter-control/filter-control.component';
import { ModalShellComponent } from './components/modal-shell/modal-shell.component';
import { ValueOrDashPipe } from './pipes/value-or-dash.pipe';
import { AchPaymentMethodsCardComponent } from './components/ach-payment-methods-card/ach-payment-methods-card.component';

@NgModule({
  declarations: [
    DisableControlDirective,
    StatusBadgeComponent,
    VehicleAgePipe,
    TruncatePipe,
    FormErrorsComponent,
    NavBarComponent,
    NgxLoadingComponent,
    NumbersOnlyDirective,
    KeyPatternControllerDirective,
    ConfirmationMsgComponent,
    DateDisplayChatPipe,
    SafeUrlPipe,
    SendEmailPopupComponent,
    AddressComponentComponent,
    CustomFieldFormComponent,
    TdCopiedComponent,
    SettingDropdownComponent,
    ImportRecordsComponent,
    ImportProductionFileComponent,
    DecimalFormatPipe,
    ExportRecordsComponent,
    PhoneNumberPipe,
    SwitchOrganizationsComponent,
    ClientsFormComponent,
    CancelQuoteComponent,
    UploadFileComponent,
    QuoteDataComponent,
    InputFieldComponent,
    ApproveCancellationComponent,
    CancelInfoComponent,
    ThirdPartiesBannerComponent,
    CapitalizeFirstLetterPipe,
    SkeletonLoaderComponent,
    CardComponent,
    NoDataComponent,
    InfoRowComponent,
    SearchInputComponent,
    SortByComponent,
    FilterByComponent,
    RadiobuttonsComponent,
    DataCardComponent,
    TableFilterBarComponent,
    StatusComponent,
    CircleProgressComponent,
    BoldLabelInfoRowComponent,
    UploadLogoComponent,
    FromUnderscoreToTextPipe,
    MenusNavBarComponent,
    DateRangeOptionsComponent,
    DateRangeSelectorComponent,
    MapToNamePipe,
    MenusChartComponent,
    HideIfDirective,
    ThirdPartyFormComponent,
    ThirdPartyValidationModalComponent,
    TimeFormatPipe,
    AssignProductToThirdPartyComponent,
    AllowZeroPipe,
    AddAttachmentModalComponent,
    ViewFileComponent,
    CopyLinkComponent,
    AddNewVehicleComponent,
    VehicleFormComponent,
    ListContractComponent,
    BulkChangeContractStatusModalComponent,
    ClaimListComponent,
    SurchargeFormComponent,
    SurchargesListComponent,
    MenuOptionComponent,
    ImportBtnComponent,
    ExportBtnComponent,
    ClaimsListCardComponent,
    PaginatorComponent,
    EmailDetailsComponent,
    HtmlContentComponent,
    EmailContentComponent,
    SendEmailSampleComponent,
    UploaddedFilesListComponent,
    TrimInputDirective,
    InputChangeDebounceDirective,
    ValidFieldInfoComponent,
    CoinsPipe,
    FileSizePipe,
    SelectProductComponent,
    ActiveFilterNamePipe,
    InfoIconComponent,
    FlaggedUserComponent,
    RemoveNullPipe,
    PendingPageComponent,
    AmericanDatetimeFormatPipe,
    DocumentPreviewComponent,
    NewNotificationsPopupComponent,
    CreateNoteModalComponent,
    CreateThirdPartyModalComponent,
    PrintQuoteContentComponent,
    RatesListComponent,
    SubClientFormComponent,
    UserActivityLogDialogComponent,
    SearchComponent,
    UpdateUserPasswordModalComponent,
    LogsComponent,
    MentionInputComponent,
    PermissionDeniedPopupComponent,
    CancelledContractsListComponent,
    ApiDropdownComponent,
    DemoBannerComponent,
    UserWidgetControlModalComponent,
    ApprovalEmailsComponent,
    AgentThirdPartiesComponent,
    AppIconComponent,
    StatCardComponent,
    StatusPillComponent,
    TabBarNewComponent,
    PageHeaderNewComponent,
    PaginationNewComponent,
    SearchInputNewComponent,
    FilterControlComponent,
    ModalShellComponent,
    ValueOrDashPipe,
    AchPaymentMethodsCardComponent,
  ],
  imports: [
    TabViewModule,
    TableModule,
    ChartModule,
    InputSwitchModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    DropdownModule,
    NgxLoadingModule,
    NgxLoadingModule,
    CheckboxModule,
    AutoCompleteModule,
    NgxSkeletonLoaderModule,
    DialogModule,
    FileInputAccessorModule,
    EditorModule,
    MultiSelectModule,
    NgxMaskModule.forChild(),
    DragDropModule,
    OverlayPanelModule,
    NgbTooltipModule,
    ProgressBarModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    RadioButtonModule,
    SplitButtonModule,
    NgbPaginationModule,
    InputTextModule,
    InputNumberModule,
    FormattedDatePipe,
    FormattedDateTimePipe,
    FormattedCurrencyPipe,
    AllLettersCapitalPipe
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    FormattedDatePipe,
    FormattedDateTimePipe,
    FormattedCurrencyPipe,
    AllLettersCapitalPipe,
    DropdownModule,
    DisableControlDirective,
    AddAttachmentModalComponent,
    ThirdPartyValidationModalComponent,
    ThirdPartyFormComponent,
    InputSwitchModule,
    MenusChartComponent,
    MenusNavBarComponent,
    RadioButtonModule,
    StatusBadgeComponent,
    DialogModule,
    CheckboxModule,
    TableModule,
    CircleProgressComponent,
    VehicleAgePipe,
    UploadFileComponent,
    CapitalizeFirstLetterPipe,
    OverlayPanelModule,
    DragDropModule,
    TruncatePipe,
    InputFieldComponent,
    FormErrorsComponent,
    NavBarComponent,
    NumbersOnlyDirective,
    NgxLoadingComponent,
    ConfirmationMsgComponent,
    DateDisplayChatPipe,
    SafeUrlPipe,
    NgxSkeletonLoaderModule,
    SendEmailPopupComponent,
    CustomFieldFormComponent,
    AddressComponentComponent,
    TdCopiedComponent,
    AutoCompleteModule,
    SettingDropdownComponent,
    ImportRecordsComponent,
    ImportProductionFileComponent,
    ExportRecordsComponent,
    SwitchOrganizationsComponent,
    DecimalFormatPipe,
    ClientsFormComponent,
    PhoneNumberPipe,
    SkeletonLoaderComponent,
    CardComponent,
    NoDataComponent,
    InfoRowComponent,
    SearchInputComponent,
    SortByComponent,
    FilterByComponent,
    UploadFileComponent,
    RadiobuttonsComponent,
    DataCardComponent,
    TableFilterBarComponent,
    SplitButtonModule,
    UploadFileComponent,
    StatusComponent,
    BoldLabelInfoRowComponent,
    UploadLogoComponent,
    FromUnderscoreToTextPipe,
    ChartModule,
    DateRangeOptionsComponent,
    MapToNamePipe,
    TagModule,
    TimeFormatPipe,
    TagModule,
    HideIfDirective,
    AllowZeroPipe,
    CopyLinkComponent,
    VehicleFormComponent,
    ListContractComponent,
    BulkChangeContractStatusModalComponent,
    ClaimListComponent,
    SurchargeFormComponent,
    SurchargesListComponent,
    MenuOptionComponent,
    ImportBtnComponent,
    ExportBtnComponent,
    InputNumberModule,
    CalendarModule,
    ClaimsListCardComponent,
    PaginatorComponent,
    EmailContentComponent,
    SendEmailSampleComponent,
    UploaddedFilesListComponent,
    TrimInputDirective,
    InputChangeDebounceDirective,
    ValidFieldInfoComponent,
    CoinsPipe,
    FileSizePipe,
    InfoIconComponent,
    FlaggedUserComponent,
    RemoveNullPipe,
    AmericanDatetimeFormatPipe,
    DocumentPreviewComponent,
    CreateThirdPartyModalComponent,
    PrintQuoteContentComponent,
    RatesListComponent,
    ThirdPartiesBannerComponent,
    SubClientFormComponent,
    SearchComponent,
    LogsComponent,
    MentionInputComponent,
    PermissionDeniedPopupComponent,
    CancelledContractsListComponent,
    ApiDropdownComponent,
    DemoBannerComponent,
    UserWidgetControlModalComponent,
    ApprovalEmailsComponent,
    AgentThirdPartiesComponent,
    AppIconComponent,
    StatCardComponent,
    StatusPillComponent,
    TabBarNewComponent,
    PageHeaderNewComponent,
    PaginationNewComponent,
    SearchInputNewComponent,
    FilterControlComponent,
    ModalShellComponent,
    ValueOrDashPipe,
    AchPaymentMethodsCardComponent,
  ],
  providers: [
    DatePipe,
    MapToNamePipe,
    FromUnderscoreToTextPipe,
    TimeFormatPipe,
    AllowZeroPipe,
    CurrencyPipe,
  ],
})
export class SharedModule {}
